import XJJSBridge from 'tools/JsBridge';

/**
 * 判断当前设备是否是ios
 */
export const isIos = (): boolean => /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);

/**
 * 判断当前设备是否是安卓
 */
export const isAndroid = (): boolean => navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;

/**
 * 判断是否是58本地版(同镇)app
 * @returns boolen
 */
export const is58TownApp = (): boolean => {
    // 因为前期同镇中接入过消金sdk，所以需要做一下过滤
    const _ua = navigator.userAgent.toUpperCase();
    return _ua.indexOf('WBUTOWN') !== -1 && _ua.indexOf('JRXJSDK') === -1;
}

/**
 * 判断是否是58app
 * @returns 
 */
export const is58App = (): boolean => {
    const _ua: string = navigator.userAgent.toUpperCase();
    // 在ios 7.3.1中 还看到有WBUA的标识，所以都判断一下吧~ 
    // 五八赶集app的ua里面有WUBA，紧急更改一次
    // 58本地app从12.0.0开始底层与58app合并，所以可以完全复用58app
    return (_ua.indexOf('GANJI') < 0 && (_ua.indexOf('WUBA') !== -1 || _ua.indexOf('WBUA') !== -1)) || is58TownApp();
}

export const isPhone = function () {
    let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return mobile !== null
}

export const isShtml = () => {
    return window.location.pathname.indexOf('.shtml') > -1
}

// 微信浏览器
export const isWeixin = function() {
    const ua = navigator.userAgent.toLowerCase();
    let flag = false;
    if (/micromessenger/.test(ua)) {
        flag = true;
    }
    return flag;
}

// 抖音浏览器
export const isDouYin = function() {
    return navigator.userAgent.toLowerCase().includes("toutiaomicroapp");
}

// 在浏览器里（排除抖音、微信、其他app宿主等）
export const isH5 = function() {
    if (getClientType() === 'h5') {
        if (isWechat() || isDouYin()) {
            return false;
        }
        return true;
    }
    return false;
}

/**
 * 判断是否在赶集app
 */
export const isGanjiApp = (): boolean => {
    const _ua: string = navigator.userAgent.toUpperCase();
    // 赶集app的UA中包含WUBA的标识，暂时这么判断(有坑就是以后赶集会不会去除WUBA的标识)
    // 这么判断的原因是，赶集app里有很多调用58app的hybrid交互，但是没有WUBA的标识不知道从哪个版本开始，如果没有WUBA标识，就走H5流程
    return _ua.indexOf('GANJI') !== -1 && _ua.indexOf('WUBA') !== -1;
}

/**
 * 判断是否是在好借app内
 */
export const isHaojieApp = (): boolean => navigator.userAgent.indexOf('JRHaoJie') > -1;

/**
 * 老版本好借app  这里的老版本指的是2019年10月底上线之前的版本叫老好借   从19年10月底上线的好借就称为新好借了
 * 好借新版app的UA信息格式为：Mozilla/5.0 (Linux; Android 8.0.0; MI 5 Build/OPR1.170623.032; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/68.0.3440.91Mobile Safari/537.36 agentweb/4.0.2  UCBrowser/11.6.4.950 JRHaoJie 99.99.99
 */
export const isOldHaojieApp = () => isHaojieApp() && !(/JRHaoJie \d+/.test(navigator.userAgent));

// 判断好借app的版本是否是好借二期重构前的版本号 二期初上线时线上会存在两个版本并行的情况，会出现三种情况
// 1.一期好借app用户无论新老用户都走一期好借+一期h5部分页面；2.二期好借app新用户走二期好借h5全流程；3.二期好借app老用户需要走一期好借h5的全流程
export const isHaojieAppV1 = (): boolean => {
    const version = getHaojieVersion();
    if (version === '0.0.0') return false;
    return compareVersion(version, '2.3.0') < 0;
};

/**
 * 判断是否是在sdk内
 */
export const isHaojieSDK = (): boolean => navigator.userAgent.indexOf('JRXJSDK') > -1;



/**
 * 检查当前微信所属环境
 * @returns 校验结果
 */
export function weChatMini(): Promise<any> {
    if (isWechat()) {
        return new Promise(resolve => {
            try {
                wx.miniProgram.getEnv(function (res) {
                    if (res.miniprogram) {
                        resolve("mini-wx");
                    } else {
                        resolve("wx");
                    }
                });
            } catch (error) {
                resolve("no-wx");
            }

        });
    } else {
        return new Promise(resolve => {
            resolve("no-wx");
        });
    }
}

/**
 * 校验是否小程序内
 * @returns 是否小程序内容
 */
export async function isWeChatMini() {
    const wxType = await weChatMini();
    return wxType === 'mini-wx'
}

/**
 * 判断是否在微信小程序内(同步方式)
 */
export function isWeChatMiniWithSync() {
    const userAgent = navigator.userAgent;
    return /miniProgram/i.test(userAgent)
}

/**
 * 判断是否是在app内
 */
export const isApp = (): boolean => isHaojieApp() || is58App();

/**
* 判断是安卓好借app或安卓好借sdk
*/
export const isAndroidAppOrSdk = (): boolean => isAndroid() && (isHaojieApp() || isHaojieSDK());

/**
 * 判断是否是小米10手机
 */
export const isMI10 = (): boolean => navigator.userAgent.indexOf('Mi 10') > -1;

/**
 * 判断是否是微信
 */
export const isWechat: () => boolean = () => (/micromessenger/i).test(navigator.userAgent);

/**
 * 
 * 判断是否为微信小程序环境
 */
export function isWxMiniprogram() {
    if (isWechat()) {
        return new Promise(resolve => {
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    // 是在微信小程序环境
                    resolve(true);
                } else {
                    // 在微信中，但不是微信小程序
                    resolve(false);
                }
            });
        });
    } else {
        // 不在微信环境中
        return new Promise(resolve => {
            resolve(false);
        });
    }
}

/**
 * 58APP10.5版本 安卓版会有一个优化 点击从手机相册选择照片时，不需要进文件页 直接进入图库选照片
 */
export const is58APPNewVersion = (): boolean => {
    if (!is58App()) return false;
    const appVersion = XJJSBridge.common.appVersion;
    return XJJSBridge.util.compareVersion(appVersion, '10.5') >= 0;
}

/**
 * 比较版本号大小
 * 返回值为：正数、0、负数
 */
export const compareVersion = (higher: string = '0.0.0', lower: string = '0.0.0'): number => {
    const _higher = String(higher);
    const _lower = String(lower);
    if (_higher === _lower) {
        return 0;
    }
    const lVerson = _higher.split('.');
    const rVersion = _lower.split('.');
    const length = lVerson.length < rVersion.length ? lVerson.length : rVersion.length;
    // 使用最小的length循环，若都相等则比较长度
    for (let i = 0; i < length; i++) {
        if (lVerson[i] !== rVersion[i]) {
            return Number(lVerson[i]) - Number(rVersion[i]);
        }
    }
    return lVerson.length - rVersion.length;
};

// 判断58同城的版本是否大于等于某个版本的
export const is58APPVersionGreaterThan = (version): boolean => {
    if (!is58App()) return false;
    try {
        const { common } = window.XJJSBridge || {};
        const { appVersion } = common || {};

        return compareVersion(appVersion, version) >= 0;
    } catch (e) {
        return false;
    }
}

/**
 * 获取好借app的版本号  如果非好借返回’0.0.0‘
 */
export const getHaojieVersion = (): string => {
    if (!isHaojieApp()) return '0.0.0';

    const versionInfo = navigator.userAgent.match(/JRHaoJie (\d+\.\d+\.\d+)/) || [];
    return versionInfo[1] || '0.0.0';
}

/**
 * 是否是版本大于等于某个版本的好借app
 */
export const isHaojieVersionGreaterThan = (version): boolean => {
    if (!isHaojieApp()) return false;

    const currentVersion = getHaojieVersion();
    return compareVersion(currentVersion, version) >= 0;
};

/**
 * 判断是在哪个客户端 人脸用
 */
export const getClientType = (): string => {
    if (is58TownApp()) {
        return '58town'; // 58本地版
    }
    if (is58App()) {
        return '58app';
    }
    if (isHaojieSDK() || isHaojieApp()) {
        return 'sdk';
    }
    return 'h5';
};

// 判断是否是集成了新人脸sdk的app 58app目前暂定大于等于10.3.0 好借app目前暂定大于等于2.3.5
export const isNewFaceSdkApp = (): boolean => {
    if (isHaojieApp()) {
        const version = getHaojieVersion();
        return compareVersion(version, '2.3.5') >= 0;
    } else if (is58App()) {
        const { appVersion = '0.0.0' } = window.WBAPP.common || {};
        return compareVersion(appVersion, '10.3.0') >= 0;
    } else {
        return false;
    }
};

/**
 * 获取操作系统
 * 返回值为：android | ios | pc | ''
 */
export const getOS = (): string => {
    try {
        if (isAndroid()) {
            return 'android';
        }
        if (isIos()) {
            return 'ios';
        }
        return 'pc';
    } catch (e) {
        return '';
    }
};

// 获取操作系统版本
export const getOSVersion = (): string => {
    try {
        let OSVision = '';
        const os = getOS();

        if (os === 'android') {
            const result = navigator.userAgent.match(/.+?;\s+.+?\s+(.+?);.*/);

            if (result) {
                OSVision = result[1].replace(/_/g, '.');
            }
        }

        if (os === 'ios') {
            const result = navigator.userAgent.split(';')[1].match(/(\d+)_(\d+)_?(\d+)?/);

            if (result) {
                OSVision = result[0].replace(/_/g, '.');
            }
        }

        return OSVision;
    } catch (e) {
        return '';
    }
};

/**
 * @description: 判断操作系统和客户端类型的对象
 * @param    {Object}  data  除了os和clientType外还需要传入的值
 * @return   {object} 返回包含操作系统和客户端类型的对象
 */
export const osAndClientType = (data: Readonly<{ [propName: string]: string }> = {}) => {
    let os = 'OTHERS';

    if (isAndroid()) {
        os = 'ANDROID';
    }

    if (isIos()) {
        os = 'IOS';
    }

    return { ...data, os, clientType: 'H5' };
};
